import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportingApiService extends ApiService {
  constructor() {
    super();
  }

  public getReportStatus$(reportTrackingId: string): Observable<ReportStatusResponseDto> {
    return this.get(`/reporting/report-status/${reportTrackingId}`);
  }

  public sendReport$(report: SendReportDto): Observable<any> {
    return this.post('/reporting/send-report', report);
  }
}

export enum ReportContent {
  Summary = 1,
  PlaybookCompliance = 2,
  KeyQuestions = 3,
  IntegrityCheck = 4,
  RegulatoryCompliance = 5,
  ReadabilityAnalysis = 6,
}

export interface SendReportDto {
  documentId: string;
  playbookId?: string;
  reportFormatId?: number;
  recipients: [string];
  reportContents?: ReportContent[];
}

export interface SendReportResponseDto {
  reportTrackingId: string;
  reportPollingFrequencySeconds: number;
  reportTimeoutSeconds: number;
}

export interface ReportStatusResponseDto {
  reportTrackingId: string;
  status: ReportStatus;
}

export enum ReportStatus {
  Unknown = 0,
  InProgress = 1,
  Error = 2,
  Success = 3,
}

export enum ReportFormat {
  PDF = 1,
  DOCX = 2,
}

export const apiReportingProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiReporting.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiReporting.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiReporting.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiReporting.scopes.write],
  },
];
